import { Link } from "react-router-dom";
import logo from "../assets/images/logo.jpeg";
import heroImg from "../assets/images/young-student-working-assignment.webp";
import avatar4 from "../assets/images/Avatar-4.png";
import avatar5 from "../assets/images/Avatar-5.png";
import avatar6 from "../assets/images/Avatar-6.png";
import avatar7 from "../assets/images/Avatar-7.png";

/**
 * AuthLayout - Premium split-screen auth layout
 * Left: Dark hero panel with logo + branding quote
 * Right: Clean white form area
 */
export default function AuthLayout({ children }) {
  return (
    <div className="min-h-screen flex bg-white font-sans">
      
      {/* LEFT: Dark Hero Panel */}
      <div className="hidden lg:flex lg:w-[45%] xl:w-[42%] bg-[#0b0f19] relative overflow-hidden flex-col justify-between p-12 xl:p-16">
        
        {/* Background image with overlay */}
        <div className="absolute inset-0">
          <img
            src={heroImg}
            alt="Learning"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0b0f19] via-[#0b0f19]/60 to-[#0b0f19]/30" />
        </div>

        {/* Decorative top-right accent */}
        <div className="absolute -top-32 -right-32 w-80 h-80 bg-primary/20 rounded-full blur-[100px]" />
        <div className="absolute bottom-32 -left-20 w-64 h-64 bg-primary/10 rounded-full blur-[80px]" />

        {/* Logo */}
        <div className="relative z-10">
          <Link to="/">
            <img src={logo} alt="E1X Academy" className="h-14 w-auto object-contain" />
          </Link>
        </div>

        {/* Quote block */}
        <div className="relative z-10">
          <div className="w-10 h-[2px] bg-primary mb-8" />
          <blockquote className="text-white text-3xl xl:text-4xl font-bold leading-snug mb-6 tracking-tight">
            "The best investment you can make is in yourself."
          </blockquote>
          <p className="text-gray-400 text-base font-light leading-relaxed max-w-sm">
            Join thousands of graduates who used E1X Academy to launch their careers in tech across the globe.
          </p>

          {/* Social proof */}
          <div className="flex items-center gap-4 mt-12">
            <div className="flex -space-x-3">
              {[avatar4, avatar5, avatar6, avatar7].map((src, i) => (
                <div key={i} className="w-9 h-9 rounded-full border-2 border-[#0b0f19] bg-gray-600 overflow-hidden">
                  <img src={src} className="w-full h-full object-cover" alt={`Graduate ${i + 1}`} />
                </div>
              ))}
            </div>
            <p className="text-gray-400 text-sm font-medium">
              <span className="text-white font-bold">1,000+</span> graduates worldwide
            </p>
          </div>
        </div>
      </div>

      {/* RIGHT: Form Area */}
      <div className="flex-1 flex flex-col justify-center items-center px-6 py-16 md:px-12 lg:px-16 xl:px-24 bg-white">
        
        {/* Mobile logo */}
        <div className="lg:hidden mb-8">
          <Link to="/">
            <img src={logo} alt="E1X Academy" className="h-12 object-contain" />
          </Link>
        </div>

        <div className="w-full max-w-md">
          {children}
        </div>
      </div>
    </div>
  );
}
